export const Symbols = {
    key: Symbol('key')
}